/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Header,
  Form,
  GridColumn,
  Icon,
  Popup,
  List,
  Message,
} from 'semantic-ui-react';
import Dropzone from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import { withTranslation } from 'react-i18next';
import ResultRenderer from '../ResultRenderer/CustomResultRenderer';
import api from '../../api';
import CveDetail from './CveDetail';
import './KnowledgeBase.css';

class SearchCveDetail extends Component {
  constructor(props) {
    super(props);
    this.typingTimeout = null;
    const { t } = props;
    this.state = {
      isError: false,
      isLoading: false,
      resultList: [],
      pageSize: 25,
      fileName: t('knowledgebase.message.drag_drop_guide'),
      //currentPage: 1,
      activeType: '',
      cveId: '',
      cveIdList: [],
      selectedList: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlurOnName = this.handleBlurOnName.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleSearchForm = this.handleSearchForm.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  handleSearchForm() {
    this.setState(
      {
        selectedList: [],
        resultList: [],
        activeType: '',
      },
      () => {
        this.getResult();
      }
    );
  }

  handleChange = (dataType, value) => {
    const { isLoading } = this.state;
    if (isLoading) {
      return;
    }

    if (dataType === 'cve_id') {
      this.setState({ cveId: value });
    }

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      if (value.trim() === '') {
        this.setState({ resultList: [] });
        return;
      }

      if (dataType === 'cve_id') {
        this.searchCveId(value, dataType);
      }
    }, 500);
  };

  handleFocus = (dataType) => {
    this.setState({ activeType: dataType });

    const { cveId } = this.state;

    if (dataType === 'cve_id') {
      if (cveId.trim() !== '') {
        this.searchCveId(cveId, dataType);
      } else {
        this.setState({ resultList: [] });
      }
    }
  };

  handleBlurOnName = () => {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }
    this.setState({
      activeType: '',
      resultList: [],
    });
  };

  handleResultSelect = (e, result) => {
    if (result.data_type === 'cve_id') {
      this.setState({
        cveId: result.name,
        activeType: '',
        resultList: [],
      });
    }
  };

  checkDataType = (type) => {
    if (type === '') {
      return true;
    }
    if (type === 'text/plain') {
      return true;
    }
    /*
    if (type === 'text/csv') {
      return true;
    }
    */
    return false;
  };

  onDrop = (file) => {
    const { t } = this.props;
    const data = file[0];
    const isAllow = this.checkDataType(data.type);

    if (!isAllow) {
      return this.setState(
        {
          fileName: t('knowledgebase.message.only_txt_file'),
          isError: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              fileName: t('knowledgebase.message.drag_drop_guide'),
              isError: false,
            });
          }, 1500);
        }
      );
    }

    const reader = new FileReader();

    reader.readAsText(data);

    reader.onload = () => {
      const array = reader.result.split(/[\r\n]+/gm);
      const filteredData = array.filter((item) => {
        return item !== '';
      });

      const checkText = filteredData.map((item) => {
        return item.toUpperCase().replace(/\s/g, '');
      });

      this.setState(
        {
          selectedList: checkText,
          cveId: '',
          pageSize: 25,
        },
        () => {
          this.getResult();
        }
      );
    };

    reader.onerror = () => {
      console.log(reader.error);
    };
  };

  getResult = () => {
    const { cveId, selectedList } = this.state;
    //const { t } = this.props;
    let obj;

    if (selectedList.length === 0) {
      obj = {
        security_names: [cveId],
      };
    } else {
      obj = {
        security_names: selectedList,
      };
    }

    this.setState({
      isLoading: true,
    });

    console.log(obj);

    api
      .getCveDetailList(obj)
      .then((response) => {
        const nextCveList = response.response.map((item) => {
          return {
            security_name: item.security_name,
            more_info: item.more_info,
          };
        });

        clearTimeout(this.typingTimeout);

        this.setState({
          cveIdList: nextCveList,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          //isScrollLoading: false,
          ///error: t('knowledgebase.error.load_error'),
          //selectedList: [],
        });
      });
  };

  searchCveId = (searchKeyword, dataType) => {
    const { pageSize } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';

    api
      .getCveList({
        search: newText,
        limit: pageSize,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        this.setState({
          activeType: `${dataType}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    const { t } = this.props;
    const {
      isError, resultList, activeType, cveId, cveIdList, fileName
    } = this.state;

    return (
      <GridColumn className="content knowledge">
        <Form className="knowledge_wrap">
          <Header as="h3">
            <Header.Content>
              <Popup
                trigger={<Icon name="question circle outline" />}
                content={t('knowledgebase.message.vuln_info_search_guide')}
                position="top left"
                size="small"
                className="question"
              />
              {t('knowledgebase.message.search_vuln_info')}
              <Header.Subheader>
                {t('knowledgebase.message.search_vuln_info_sub_tilte')}
              </Header.Subheader>
            </Header.Content>
          </Header>
          <Form.Group>
            <Form.Field>
              <Form.Input
                className="nameInput"
                type="text"
                placeholder={t('knowledgebase.place_holder.cve_id')}
                value={cveId}
                onChange={(e) => {
                  return this.handleChange('cve_id', e.target.value);
                }}
                onFocus={(e) => {
                  return this.handleFocus('cve_id', e.target.value);
                }}
                onBlur={this.handleBlurOnName}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeType === 'cve_id'}
                translate={t}
              />
            </Form.Field>
            <Form.Field>
              <Form.Button
                className="search"
                style={{ width: '100px' }}
                content={t('knowledgebase.button.search')}
                disabled={cveId === ''}
                onClick={this.handleSearchForm}
              />
            </Form.Field>
          </Form.Group>
          <Header as="h3">
            <Header.Content>
              <Popup
                trigger={<Icon name="question circle outline" />}
                position="top left"
                size="small"
                className="question"
              >
                <div className="text">
                  <span className="title">
                    {t('knowledgebase.format_file_import')}
                  </span>
                  <List bulleted>
                    <List.Item>
                      {t('knowledgebase.message.guide_dropzone_txt')}
                    </List.Item>
                    <List.Item>
                      {t(
                        'knowledgebase.message.guide_dropzone_contain_cve_info'
                      )}
                    </List.Item>
                  </List>
                </div>
              </Popup>
              {t('knowledgebase.import_a_file')}
            </Header.Content>
          </Header>
          <Form.Group>
            <div className="dropzone_wrap">
              <Dropzone onDrop={this.onDrop}>
                {({ getRootProps, getInputProps }) => {
                  return (
                    <div {...getRootProps({ className: 'drop_files_here' })}>
                      <input {...getInputProps()} />
                      <span className="icon">
                        {!isError ? (
                          <Icon
                            name="cloud upload"
                            size="big"
                            style={{
                              color: '#dddddd',
                              display: 'inline-block',
                              margin: '14px',
                            }}
                          />
                        ) : (
                          <Icon
                            name="ban"
                            size="big"
                            style={{
                              color: '#dddddd',
                              display: 'inline-block',
                              margin: '14px',
                            }}
                          />
                        )}
                      </span>
                      {isError ? (
                        <p className="file_info error">{fileName}</p>
                      ) : (
                        <p className="file_info">{fileName}</p>
                      )}
                    </div>
                  );
                }}
              </Dropzone>
            </div>
          </Form.Group>
          <div className="header_wrap">
            <Header as="h3">
              <Header.Content>
                {t('knowledgebase.search_result')}
              </Header.Content>
            </Header>
          </div>
          <Form.Group>
            <div className="result_wrap">
              {cveIdList.length !== 0 ? (
                <div>
                  {cveIdList.map((item) => {
                    return (
                      <CveDetail key={uuidv4()} rowData={item} translate={t} />
                    );
                  })}
                </div>
              ) : (
                <Message warning style={{ display: 'block' }}>
                  <Message.Header>
                    {t('knowledgebase.message.no_results_found')}
                  </Message.Header>
                </Message>
              )}
            </div>
          </Form.Group>
        </Form>
      </GridColumn>
    );
  }
}
export default withTranslation()(SearchCveDetail);
